// @flow

import worldMap from '../core/map';
import sidebar from '../core/sidebar';
import layers from '../layers';
import environment from '../environment';
import moment from "moment";
import api from '../api';

export class CoreControl {
    _instance;
    options;

    constructor(options = {}) {
        this.options = options;

        this._change = this._change.bind(this);
        this.get = this.get.bind(this);
        this.getControls = this.getControls.bind(this);
        this.getLayer = this.getLayer.bind(this);
        this.purge = this.purge.bind(this);
        this.setOptions = this.setOptions.bind(this);
    }

    setOptions(options) {
        this._instance.options = options;
    }

    check(state, change) {
        if (this._instance) {
            return this._instance.check(state, change);
        }
        return false;
    }

    async _change(e, onComplete = null) {
        try {
            api.general.log.action(environment._getContextEnum(this.options.name), e.checked ? 'enable' : 'disable');
            const layer = this.getLayer();

            if (e.checked) {
                try {
                    if (!layer.isEmpty() && layer.samePosition()) {
                        await layer.reload();
                    } else {
                        await layer.redraw();
                    }
                } catch (err) {
                    await layer.redraw();
                }

            } else {
                layer.hide();
            }
            if (onComplete) {
                onComplete();
            };
        } catch (err) {
            console.log('ERROR: ', err);
        }
    }

    getControls(id = worldMap.getCurrent()._id) {
        return sidebar.getControls(id, this.options.name);
    }

    getOptions() {
        return this.options;
    }

    getLayer(currentMap = worldMap.getCurrent(), name) {
        if (typeof currentMap === 'number') {
            return layers.get(name || this.options.name, worldMap.get(currentMap));
        }
        return layers.get(name || this.options.name, currentMap);
    }

    get currentDatePeriod() {
        const period = (this).layerPeriod;
        return {
            start: new Date(period.start),
            end: new Date(period.end),
        };
    }

    get periodLimits() {
        const period = (this).layerPeriod;
        return {
            max: period.max || environment.get('CONFIG.FILTERS.ENDYEAR'),
            min: period.min || environment.get('CONFIG.FILTERS.STARTYEAR')
        };
    }

    get() {
        return this._instance.options;
    }

    formattedPeriod() {
        const { start, end } = (this).period;
        const formatDate = (date) => moment(date).format('MM/YYYY');
        return `${formatDate(start)} - ${formatDate(end)}`;
    }

    get currentPeriod() {
        const { start, end } = (this).period;

        const formatDate = (dt) => moment(dt).format("MM/YYYY");
        return { start: formatDate(start), end: formatDate(end) };
    }

    purge() {
        if (this.check() && this.getLayer().visible()) {
            this.getLayer().reset();
        }
    }
}

export default CoreControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/CoreControl.js